/* eslint-disable max-len */
const REGIONS = {
    EUROPE: 'europe',
    WORLDWIDE_EXCL: 'world_excl',
    WORLDWIDE_INCL: 'world_incl'
};

const MAX_NUMBER_OF_TRAVELLERS = 10;
const MAX_ESSENTIAL_SINGLE_TRIP_DURATION_DAYS = 30;

const SINGLE_TRIP_CANCELLATION_LIMITS = {
    essential: 2500,
    standard: 5000,
    plus: 15000
};

const UPGRADE_TO_ANNUAL_CANCELLATION_LIMIT = 10000;

const MAX_SINGLE_TRIP_LENGTH = {
    EUROPE: 180,
    WORLD: 120
};

const PRODUCT_TYPE = {
    ANNUAL: 'annual',
    SINGLE_TRIP: 'single_trip'
};

const COVER_LEVELS = {
    ESSENTIAL: 'essential',
    STANDARD: 'standard',
    PLUS: 'plus',
    SELECT: 'select'
};

const AGGS_COVER_LEVEL_CODES = ['select_annual', 'select_single'];
const AGGS_COVER_LEVEL_NAME = 'Select';

const TRIP_EXTENSIONS = {
    DAYS_45: '45days',
    DAYS_60: '60days',
    DAYS_90: '90days'
};

const TYPE_OF_TRIPS = {
    BUSINESS: 'business',
    CRUISE: 'cruise'
};

const COUNTRY_CODES = {
    AUSTRALIA: '19',
    FRANCE: '89',
    ITALY: '124',
    PORTUGAL: '188',
    SPAIN: '216',
    TENERIFE: '235',
    UK: '251',
    USA: '248',
    CHANNEL_ISLANDS: '54',
    GUERNSEY: '313',
    WALES: '262',
    ISLE_OF_MAN: '123',
    SCOTLAND: '206',
    NORTHERN_IRELAND: '282',
    SCILLY_ISLES: '205',
    JERSEY: '318',
    OTHER: 'other',
};

// TODO 2 country codes missing (999, 998 placeholders)
const LOADER_SPECIFIC_COUNTRY_CODES = [
    '89',
    '124',
    '188',
    '216',
    '999',
    '235',
    '998',
    '248',
    '19'
];

const TRIP_CANCELLATION_VALUE_BRACKETS = {
    UP_TO_1500: 'UP_TO_1500',
    UP_TO_3000: 'UP_TO_3000',
    UP_TO_5000: 'UP_TO_5000',
    UP_TO_7500: 'UP_TO_7500',
    UP_TO_15000: 'UP_TO_15000',
    OVER_15000: 'OVER_15000'
};

const ADOBE_QUOTE_STEPS = {
    DETAILS_STEP: 'step 1|details',
    MEDICAL_STEP: 'step 2|medical declaration',
    QUOTE_STEP: 'step 3|quote',
    PAYMENT_STEP: 'step 4|payment',
    CONFIRMATION_STEP: 'step 5|confirmation',
};

const ADOBE_QUOTE_STEPS_AGGS = {
    QUOTE_STEP: 'step 3|quote',
    DECLARATION_STEP: 'step 4|declaration',
    PAYMENT_STEP: 'step 5|payment',
    CONFIRMATION_STEP: 'step 6|confirmation'
};

const ADOBE_REGION_VALUES = {
    EUROPE: 'Europe',
    WORLDWIDE_INCL: 'Worldwide including USA',
    WORLDWIDE_EXCL: 'Worldwide excluding USA'
};

const QUOTE_COMPLETE = 'complete';

const EXCESS_CODES = {
    EXCESS_0: '0_excess',
    EXCESS_70: '70_excess',
    EXCESS_150: '150_excess',
    EXCESS_250: '250_excess'
};

const EXCLUSION_CODES = {
    WINTER_SPORTS: 'screening_winter_sports',
    ANNUAL: 'screening_annual'
};

const PRE_QUOTE_PAGE_URLS = ['/journey/details', '/journey/medical', '/journey/singleTripOffer'];

const SG_TRAVEL_ERROR_REASONS = {
    TERMINAL_ILLNESS_OR_TRAVEL_AGAINST_ADVICE: 9330,
    ON_WAITING_LIST_AND_UNDIAGNOSED: 9331,
    UNDER_INVESTIGATION: 9332,
    MEDICAL_RISK_THRESHOLD_EXCEEDED: 9450,
    SINGLE_TRIP_DUPLICATE: 9451,
    ANNUAL_TRIP_DUPLICATE: 9452
};

const TRAVEL_ADVISER_DIRECTORY_LINK = 'https://traveldirectory.moneyhelper.org.uk';
const IMPORTANT_INFORMATION_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/travel/saga-travel-insurance-important-information.pdf?cd=view';
const POLICY_BOOKLET_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/travel/saga-standard-and-plus-travel-insurance-policy-book.pdf?cd=view';
const POLICY_BOOKLET_LINK_ESSENTIAL = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/travel/saga-essential-travel-insurance-policy-book.pdf?cd=view';

const SELECT_POLICY_INFO_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/travel-select/saga-select-travel-insurance-important-information.pdf?cd=view';
const SELECT_POLICY_BOOKLET_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/travel-select/saga-select-travel-insurance-policy-book.pdf?cd=view';
const ESSENTIAL_REASONS_LINK = 'https://www.saga.co.uk/travel-insurance/coronavirus#anchor_Essentialreasonsfortravel';

const WIZARD_STEP_URLS = {
    DETAILS_PAGE: '/details'
};

const SINGLE_TRIP_COVER_LEVELS_TABLE_ROW_IDS = {
    CANCELLATION: 'cancellation',
    EXCESS: 'excess',
    MEDICAL_EXPENSES: 'medicalExpenses',
    LOST_STOLEN_BAGGAGE: 'lostStolenDamagedBaggage',
    DELAYED_DEPARTURE: 'delayedDeparture',
    DELAYED_FLIGHT_ASSISTANCE: 'delayedFlightAssistance',
    ENFORCED_STAY: 'enforcedStay',
    MISSED_DEPARTURE: 'missedDeparture',
    ABANDONMENT: 'abandonment',
    PERSONAL_ACCIDENT: 'personalAccident',
    SUBSTITUTE_ACCOMMODATION: 'substituteAccommodation',
    PERSONAL_MONEY: 'personalMoney',
    PERSONAL_LIABILITY: 'personalLiability',
    LEGAL_EXPENSES: 'legalExpenses',
    CRUISE_MISSED_PORT: 'cruiseMissedPort',
    CRUISE_REJOIN: 'cruiseRejoin',
    DELAYED_BAGGAGE: 'delayedBaggage',
    HOSPITAL_BENEFIT: 'hospitalBenefit',
    CRIMINAL_INJURY: 'criminalInjury',
    LOSS_OF_PASSPORT: 'lossOfPassport',
    END_SUPPLIER_FAILURE: 'endSupplierFailure',
    PET_CARE: 'petCare',
    HIJACK_AND_MUGGING: 'hijackAndMugging',
    AIR_RAGE: 'airRage'
};

const SAGA_TRAVEL_INSURANCE = 'travel';
const FAQ_QUESTIONS_KEYS = ['fcdoAdvice', 'europeanUnion', 'policyType', 'startPolicy', 'medicalDetails'];

const TRAVEL_CLAIM_PHONE_NUMBERS = {
    PHONE_NUMBER_CLAIM_TYPE_MED_OR_PASSPORT_ABROAD: '+44 1444 442105',
    PHONE_NUMBER_CLAIM_TYPE_MED_OR_PASSPORT: '0800 092 2101',
    PHONE_NUMBER_CLAIM_TYPE_BELONGINGS_CANX: '0800 092 2099',
    PHONE_NUMBER_CLAIM_TYPE_BELONGINGS_CANX_ABROAD: '+44 1444 442106',
    PHONE_NUMBER_CLAIM_HELP_ABROAD: '+44 1444 442141',
    PHONE_NUMBER_CLAIM_HELP: '0800 092 2344',
};

const PHONE_NUMBER_CUSTOMER_SERVICE = '0800 904 7489';
const PHONE_NUMBER_DOCUMENTS = '0800 904 7489';
const PHONE_NUMBER_EXISTING_CUSTOMER = '0800 904 7764';
const PHONE_NUMBER_NEW_CUSTOMERS_MTA = '0800 056 9200';
const PHONE_NUMBER_NOT_CURRENTLY_INSURED = '0800 015 8055';

const SPT = 'spt';

const CANCELLATION_AMOUNT = {
    ESSENTIAL: '2,500',
    STANDARD: '5,000',
    STANDARD_ANNUAL: '10,000',
    PLUS_ANNUAL: '20,000',
};

const MISSED_DEPARTURE_AMOUNT = {
    STANDARD: '500',
    PLUS: '1,000',
    SELECT: '1,000',
    STANDARD_ANNUAL: '750',
    PLUS_ANNUAL: '1,500',
    SELECT_ANNUAL: '1,000'
};

const DELAYED_FLIGHT = {
    STANDARD: '2',
    PLUS: '1',
    STANDARD_ANNUAL: '2',
    PLUS_ANNUAL: '1',
};

const CRIMINAL_INJURY = {
    STANDARD: '20,000',
    PLUS: '30,000',
    SELECT: '30,000',
    STANDARD_ANNUAL: '20,000',
    PLUS_ANNUAL: '30,000',
    SELECT_ANNUAL: '30,000'
};

const PET_CARE = {
    STANDARD: '100',
    PLUS: '200',
    STANDARD_ANNUAL: '150',
    PLUS_ANNUAL: '350',
};

const DELAYED_BAGGAGE = {
    STANDARD: '150',
    PLUS: '400',
    SELECT: '250',
    STANDARD_ANNUAL: '150',
    PLUS_ANNUAL: '400',
    SELECT_ANNUAL: '250'
};

const HOSPITAL_BENEFIT = {
    STANDARD: '1,000',
    PLUS: '1,500',
    SELECT: '1,000',
    STANDARD_ANNUAL: '1,000',
    PLUS_ANNUAL: '1,500',
    SELECT_ANNUAL: '1,000'
};

const PASSPORT_AMOUNT = {
    ESSENTIAL: '250',
    STANDARD: '500',
    PLUS: '750',
    SELECT: '500',
    STANDARD_ANNUAL: '500',
    PLUS_ANNUAL: '1,000',
    SELECT_ANNUAL: '500'
};

const DELAYED_DEPARTURE = {
    ESSENTIAL: '215',
    STANDARD: '215',
    PLUS: '300',
    SELECT: '215',
    STANDARD_ANNUAL: '215',
    PLUS_ANNUAL: '300',
    SELECT_ANNUAL: '215'
};

const PERSONAL_MONEY_AMOUNT = {
    ESSENTIAL: '250',
    STANDARD: '500',
    PLUS: '750',
    SELECT: '500',
    STANDARD_ANNUAL: '500',
    PLUS_ANNUAL: '1,000',
    SELECT_ANNUAL: '500'
};

const PERSONAL_LIABILITY_AMOUNT = {
    ESSENTIAL: '2,000,000',
    STANDARD: '2,000,000',
    PLUS: '3,000,000',
    SELECT: '2,000,000',
    STANDARD_ANNUAL: '2,000,000',
    PLUS_ANNUAL: '3,000,000',
    SELECT_ANNUAL: '2,000,000'
};

const MEDICAL_EXPENSES_AMOUNT = {
    ESSENTIAL: '2,000,000',
    STANDARD: '5,000,000',
    PLUS: '15,000,000',
    STANDARD_ANNUAL: '10,000,000',
    PLUS_ANNUAL: '20,000,000',
};

const DENTAL_EMERGENCY = {
    ESSENTIAL: '300',
    STANDARD: '400',
    PLUS: '500',
    STANDARD_ANNUAL: '400',
    PLUS_ANNUAL: '500',
};

const ABANDONMENT_AMOUNT = {
    ESSENTIAL: '2,500',
    STANDARD: '5,000',
    PLUS: '15,000',
    SELECT: '2,500',
    STANDARD_ANNUAL: '10,000',
    PLUS_ANNUAL: '20,000',
    SELECT_ANNUAL: '2,500'
};

const PERSONAL_ACCIDENT_AMOUNT = {
    STANDARD: '20,000',
    PLUS: '30,000',
    SELECT: '30,000',
    STANDARD_ANNUAL: '20,000',
    PLUS_ANNUAL: '30,000',
    SELECT_ANNUAL: '30,000'
};

const PA_DEATH_BENEFIT = {
    STANDARD: '10,000',
    PLUS: '15,000',
    SELECT: '15,000',
    STANDARD_ANNUAL: '10,000',
    PLUS_ANNUAL: '15,000',
    SELECT_ANNUAL: '15,000'
};

const SUBSTITUTE_ACCOMMODATION_AMOUNT = {
    STANDARD: '1,500',
    PLUS: '5,000',
    SELECT: '2,500',
    STANDARD_ANNUAL: '1,500',
    PLUS_ANNUAL: '5,000',
    SELECT_ANNUAL: '2,500'
};

const ENFORCED_STAY_AMOUNT = {
    STANDARD: '1,500',
    PLUS: '2,000',
    SELECT: '1,500',
    STANDARD_ANNUAL: '1,500',
    PLUS_ANNUAL: '2,000',
    SELECT_ANNUAL: '1,500',
};

const MAX_INITIAL_TRAVELLERS_NUMBER_ON_RENEWAL = 4;

const VERISK_V3_EVENT_TYPES = {
    COMPLETE_SCREENING: 'COMPLETE_SCREENING',
    SAVE_SCREENING: 'SAVE_SCREENING',
    RESUME_SCREENING: 'RESUME_SCREENING',
};

const VERISK_V3_USER_NAME = {
    VERISK_UAT_USER: 'RRT3SagaUKTravelUAT',
    VERISK_PROD_USER: 'RRT3SagaUKTravelProd'
};

const VERISK_V3_ROOT_URL = {
    VERISK_UAT_ROOT_URL: 'https://gatewayuat.verisk.com/rating/uk/travel/',
    VERISK_PROD_ROOT_URL: 'https://gateway.verisk.com/rating/uk/travel/'
};

export default {
    COUNTRY_CODES,
    TYPE_OF_TRIPS,
    MAX_INITIAL_TRAVELLERS_NUMBER_ON_RENEWAL,
    MAX_ESSENTIAL_SINGLE_TRIP_DURATION_DAYS,
    SINGLE_TRIP_CANCELLATION_LIMITS,
    UPGRADE_TO_ANNUAL_CANCELLATION_LIMIT,
    PHONE_NUMBER_EXISTING_CUSTOMER,
    PHONE_NUMBER_NEW_CUSTOMERS_MTA,
    PHONE_NUMBER_NOT_CURRENTLY_INSURED,
    EXCESS_CODES,
    REGIONS,
    PRODUCT_TYPE,
    COVER_LEVELS,
    AGGS_COVER_LEVEL_CODES,
    AGGS_COVER_LEVEL_NAME,
    TRIP_EXTENSIONS,
    MAX_NUMBER_OF_TRAVELLERS,
    MAX_SINGLE_TRIP_LENGTH,
    PRE_QUOTE_PAGE_URLS,
    ADOBE_QUOTE_STEPS,
    ADOBE_QUOTE_STEPS_AGGS,
    SELECT_POLICY_INFO_LINK,
    SELECT_POLICY_BOOKLET_LINK,
    TRIP_CANCELLATION_VALUE_BRACKETS,
    SG_TRAVEL_ERROR_REASONS,
    TRAVEL_ADVISER_DIRECTORY_LINK,
    WIZARD_STEP_URLS,
    EXCLUSION_CODES,
    IMPORTANT_INFORMATION_LINK,
    POLICY_BOOKLET_LINK,
    POLICY_BOOKLET_LINK_ESSENTIAL,
    ESSENTIAL_REASONS_LINK,
    SINGLE_TRIP_COVER_LEVELS_TABLE_ROW_IDS,
    TRAVEL_CLAIM_PHONE_NUMBERS,
    SAGA_TRAVEL_INSURANCE,
    LOADER_SPECIFIC_COUNTRY_CODES,
    SPT,
    FAQ_QUESTIONS_KEYS,
    PHONE_NUMBER_CUSTOMER_SERVICE,
    PHONE_NUMBER_DOCUMENTS,
    QUOTE_COMPLETE,
    ADOBE_REGION_VALUES,
    CANCELLATION_AMOUNT,
    PASSPORT_AMOUNT,
    DELAYED_DEPARTURE,
    PERSONAL_MONEY_AMOUNT,
    PERSONAL_LIABILITY_AMOUNT,
    MEDICAL_EXPENSES_AMOUNT,
    DENTAL_EMERGENCY,
    ABANDONMENT_AMOUNT,
    MISSED_DEPARTURE_AMOUNT,
    DELAYED_FLIGHT,
    CRIMINAL_INJURY,
    PET_CARE,
    DELAYED_BAGGAGE,
    HOSPITAL_BENEFIT,
    PERSONAL_ACCIDENT_AMOUNT,
    PA_DEATH_BENEFIT,
    SUBSTITUTE_ACCOMMODATION_AMOUNT,
    ENFORCED_STAY_AMOUNT,
    VERISK_V3_EVENT_TYPES,
    VERISK_V3_USER_NAME,
    VERISK_V3_ROOT_URL
};
